import { render, staticRenderFns } from "./admindialog.vue?vue&type=template&id=08699f56&scoped=true"
import script from "./admindialog.vue?vue&type=script&lang=js"
export * from "./admindialog.vue?vue&type=script&lang=js"
import style0 from "./admindialog.vue?vue&type=style&index=0&id=08699f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08699f56",
  null
  
)

export default component.exports